/**
 * Compatibility helper for the legacy Gift PDF page.
 *
 * The page still requests a product through the removed
 * `fetchStorefrontApiQuery` helper and expects the old Storefront GraphQL
 * response shape. Use Shopify's public, same-origin product JSON endpoint and
 * adapt its response so existing Gift PDF page content can keep working.
 */
window.fetchStorefrontApiQuery = async function fetchStorefrontApiQuery(params) {
  const handle = params && params.variables && params.variables.handle;

  if (typeof handle !== 'string' || !/^[a-z0-9][a-z0-9-]*$/i.test(handle)) {
    throw new Error('A valid product handle is required.');
  }

  const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Unable to load product "${handle}" (${response.status}).`);
  }

  const product = await response.json();
  const featuredImage = product.featured_image || product.images?.[0] || null;
  const imageUrl = featuredImage
    ? new URL(featuredImage, window.location.origin).href
    : null;

  return {
    json: async function json() {
      return {
        data: {
          productByHandle: {
            title: product.title,
            images: {
              edges: imageUrl ? [{ node: { originalSrc: imageUrl } }] : [],
            },
          },
        },
      };
    },
  };
};
